import _ from 'lodash'
import $ from 'jquery'

var instances = []
var eventListeners = {}

var getToastAlertFunction = (message, type = 'info', config = {}) => {
  var defaultProps = {
    id: '',
    type,
    toast: true,
    center: false,
    noIcon: false,
    clickToClose: true,
    block: false,
    closer: true,
    size: 'full',
    classes: '',
    containerClass: ''
  };

  var props = _.merge({}, defaultProps, _.pick(config || {}, Object.keys(defaultProps)))

  var {target = 'body', options = {}, prepend, before, after, onInit, onClick, onUpdate, onBeforeUpdate, onBeforeClose, onClose} = config
  Object.assign(options, {prepend, before, after, onInit, onClick, onUpdate, onBeforeUpdate, onBeforeClose, onClose})

  return inject(target, {props, message, target, options})
}
getToastAlertFunction.$instance = (id) => {
  if (!id) {
    return instances
  }
  return instances[id]
}

// init, click, beforeUpdate, update, beforeClose, close,
getToastAlertFunction.on = (eventName, callback) => {
  var listeners = eventListeners[eventName] || (eventListeners[eventName] = [])
  listeners.push(callback)
}

var inject = (target = 'body', config) => {

  var {message = '', props = {}, options = {}} = config
  target = config.target || target

  var element = getToastElement(props)
  if (message) {
    setContent(message, element)
  }

  let targetElm = target
  if (_.isString(target)) {
    targetElm = $.find(target)
  }
  config.targetElm = targetElm

  if (options.prepend) {
    element.prependTo(targetElm)
  } else if (options.before) {
    element.insertBefore(targetElm)
  } else if (options.after) {
    element.insertAfter(targetElm)
  } else {
    element.appendTo(targetElm)
  }

  var instance = getInstance(element, config)
  return instance
}

var setContent = (message, element) => {
  if (_.isString(message)) {
    element.find('.re-toast-alert-content').html(message)
  } else {
    _.forOwn(message, (value, slotName) => {
      element.find(`.slot-${slotName}`).html(value)
    })
  }
}

var getToastElement = (options) => {

  var closeElm = options.closer ? '<div class="re-toast-alert-close slot-close"></div>' : ''
  var id = options.id ? ` data-toast-id="${options.id}"` : ''

  return $(`<div class="re-toast-alert-container" ${id}>
      <div class="re-toast-alert">
        <div class="re-toast-alert-content slot-default"></div>      
        ${closeElm}        
      </div>
    </div>`)

}

var getInstance = (element, config) => {

  var instance = {$el: element, config, noVue: true}

  initHelper(instance)

  instances.push(instance)
  if (config.props.id) {
    instance.$id = config.props.id
    instances[config.props.id] = instance
  }

  emit('init', {}, instance)
  return instance
}

var helpers = {
  close() {
    this.closeMe(null)
  },
  update(options) {
    // message, type
    emit('beforeUpdate', options, this.$instance)

    if (options.message) {
      setContent(options.message, this.$el)
    }
    if (options.type) {
      this.setType(options.type)
    }
    emit('update', options, this.$instance)
  },
  setType(type) {
    var elmPrefix = 're-toast-alert'
    var elm = this.$el.find('.' + elmPrefix)
    elm.removeClass(elmPrefix + '-' + this.type).addClass(elmPrefix + '-' + type)
  },

  myClasses() {
    return _.transform({
      're-toast-alert-fly': this.toast,
      're-toast-alert-inline': !this.toast,
      're-toast-alert-center': this.center,
      're-toast-alert-no-center': !this.center,
      're-toast-alert-no-icon': this.noIcon,
      're-toast-alert-clickable': this.clickToClose,
      ['re-toast-alert-' + this.type]: true,
      ['re-toast-alert-size-' + this.size]: !this.getSizeStyle(),
    }, (result, v, k) => {
      (v && result.push(k))
    }, [this.classes || '']).join(' ')
  },
  containerClasses() {
    return _.transform({
      'blocked-screen': this.block,
    }, (result, v, k) => {
      (v && result.push(k))
    }, [this.containerClass || '']).join(' ')
  },
  getStyles() {
    return _.merge({}, this.getSizeStyle())
  },
  myStyles() {
    return this.getStyles() || {}
  },
  getSizeStyle() {
    var size = this.size || ''
    var isStyle = /^(\d+?)?(\.\d+?)?(px|%)?$/.test(size)
    if (isStyle) {
      var width = (size + '').replace(/(\d$)/, '$1px')
      return {width}
    }
    return null
  },

  closeMe(event) {
    this.$el.remove()
    emit('close', {event}, this.$instance)
  },
  bodyClicked(event) {
    var isCancel = emit('click', {event}, this.$instance) === false
    if (!isCancel && this.clickToClose) {
      this.closeMe(event, this.$instance)
    }
  },
  closeClicked(event) {
    var isCancel = emit('beforeClose', {event}, this.$instance) === false
    if (!isCancel) {
      this.closeMe(event)
    }
  }

}

var initHelper = (instance) => {

  var elm = instance.$el
  var options = instance.config;

  var helper = instance.helper = getHelper(options.props, elm, options, instance)

   instance.close = instance.$close = () => {
    helper.closeMe()
  }

  instance.update = instance.$update = (options) => {
    helper.update(options)
  }

  instance.$on = (name, callback, replace = true) => {
    var helperEventName = '$' + _.camelCase('on-' + name)
    if (replace) {
      instance[helperEventName] = callback
    } else {
      var existing = instance[helperEventName] || (() => {
      })
      instance[helperEventName] = (args, instance) => {
        existing(args, instance)
        return callback(args, instance)
      }
    }
  }

  elm.find('.re-toast-alert-close')
    .click(function (e) {
      helper.closeClicked(e)
    })

  elm.addClass(helper.containerClasses())
    .click(function (e) {
      helper.bodyClicked(e)
    })

  elm.find('.re-toast-alert').addClass(helper.myClasses()).css(helper.myStyles())
    .click(function (e) {
      helper.bodyClicked(e)
    })
  return elm
}

var emit = (name, args, instance) => {
  args = _.merge({}, instance, (args || {}))

  var helperEventName = '$' + _.camelCase('on-' + name)
  let ret = null
  if (instance.helper[helperEventName]) {
    ret = instance.helper[helperEventName](args, instance)
  }
  var listeners = eventListeners[name] || []

  ret = _.reduce(listeners, (ret, listener) => {
    var newRet = listener(args, instance)
    return newRet === false ? newRet : ret
  }, ret)

  return ret
}

var getHelper = (props, $el, $config, $instance) => Object.assign(
  {},
  helpers,
  props,
  {$el},
  {$config},
  {$instance},
  {
    $onInit: $config.options.onInit,
    $onClick: $config.options.onClick,
    $onBeforeUpdate: $config.options.onBeforeUpdate,
    $onUpdate: $config.options.onUpdate,
    $onBeforeClose: $config.options.onBeforeClose,
    $onClose: $config.options.onClose,
  },
)

export var toastAlert = window.toastAlert || (window.toastAlert = getToastAlertFunction)
